import React, { HTMLAttributes } from 'react'

import { Box, cn } from '@podo-app/design-system-temp'

const TopStickyContainer = ({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <Box className={cn('sticky top-[var(--safe-area-inset-top)] bg-white z-40', className)} {...props}>
      {children}
    </Box>
  )
}

export default TopStickyContainer
